import axios from 'axios'
import JSONbig from 'json-bigint'
import router from '@/router'
import { getToken, clearToken, redirectToOauth } from '@/utils/wxsession'
// import router from '@/router'
// 非组件模块可以这样加载使用 element 的 message 提示组件
// import { Message, MessageBox } from 'element-ui'

// 实例一个axios
const request = axios.create({
	baseURL: 'https://api.gangerp.com',
	transformResponse: [
		function (data) {
			try {
				return JSONbig.parse(data)
			} catch (err) {
				console.log('转换失败', err)
				return data
			}
		}
	]
})

// 请求拦截器
request.interceptors.request.use(
	function (config) {
		let user = null
		try {
			user = JSON.parse(window.localStorage.getItem('user'))
		} catch (e) {
			user = null
		}
		if (user) {
			config.headers.Authorization = `${user.token}`
		}
		// 企业微信会话票据统一走请求头，业务代码不必再手工传 code
		const wxToken = getToken()
		if (wxToken) {
			config.headers['X-WX-Token'] = wxToken
		}
		return config
	},
	function (error) {
		return Promise.reject(error)
	}
)

// 响应拦截器
request.interceptors.response.use(
	function (response) {
		// 所有响应码为 2xx 的响应都会进入这里
		// response 是响应处理
		// 注意：一定要把响应结果 return，否则真正发请求的位置拿不到数据

		// 企业微信票据失效：后端用 HTTP 200 + reauth 标记下发，这里统一自愈重新授权。
		// 换票接口本身的失败由 wxauth 处理，不在这里拦，避免重复跳转。
		const body = response.data
		const url = (response.config && response.config.url) || ''
		if (body && body.reauth === true && url.indexOf('/api/wxLogin') === -1) {
			clearToken()
			redirectToOauth()
		}
		return response
	},
	function (error) {
		// 网络中断 / 超时 / 跨域失败时 error.response 是 undefined，
		// 原来直接解构会抛 TypeError，把真实错误吞掉
		if (!error || !error.response) {
			return Promise.reject(error)
		}
		const { status } = error.response
		// 任何超出 2xx 的响应码都会进入这里
		if (status === 403) {
			// 跳转到登录页面
			// 清除本地存储中的用户登录状态
			window.localStorage.removeItem('user')
			router.push('/login')
			// Message.error('登录状态无效，请重新登录')
		} else if (status === 400) {
			// 客户端会员过期
			window.localStorage.removeItem('user')
			/* ElMessageBox.alert('会员停用或过期。', '消息提示', {
				confirmButtonText: '确定',
				callback: action => {
					window.localStorage.removeItem('user')
					router.push('/login')
				}
			}) */
		} else if (status === 401) {
			// 客户端权限
			/* MessageBox.alert('您没有权限。', '消息提示', {
				confirmButtonText: '确定',
				callback: action => {
					window.localStorage.removeItem('user')
					router.push('/login')
				}
			}) */
			// ElMessage.error('您没有权限操作。')
		} else if (status === 402) {
			// 客户端会员过期
			window.localStorage.removeItem('user')
			/* ElMessageBox.alert('会员停用或过期。', '消息提示', {
				confirmButtonText: '确定',
				callback: action => {
					window.localStorage.removeItem('user')
					router.push('/login')
				}
			}) */
		} else if (status === 418) {
			// 客户端会员在其他方登录
			// 跳转到登录页面
			// 清除本地存储中的用户登录状态
			window.localStorage.removeItem('user')
			router.push('/login')
		} else if (status >= 500) {
			// ElMessage.error('服务端内部异常，请稍后重试')
		}

		return Promise.reject(error)
	}
)

export default request
